<script>
import Layout from '@/router/layouts/main';
import textMixin from '../../../../mixins/textMixin';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Repositories from '@/repositories';
const UsersRepository = Repositories.get('users');
import GridComponent from '@/components/widgets/grids/pagination-grid';

/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'Users',
  },
  mixins: [textMixin],
  components: {
    Layout,
    Loading,
    GridComponent,
  },
  data() {
    return {
      isLoading: false,
      searchText: '',
      items: [
        {
          text: 'users',
          href: '/configuration/users',
        },
        {
          text: '',
          active: true,
        },
      ],
      list: [],
      statues: [
        {
          code: 'ADMIN',
          name: this.$t('users.admin'),
          html:
            '<span class="badge badge-primary badge-pill" style="font-size: 1em">' +
            this.$t('users.admin') +
            '</span>',
        },
        {
          code: 'STANDARD',
          name: '',
          html: '<span></span>',
        },
      ],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      UsersRepository.getAll()
        .then((response) => {
          this.list = response.data.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    edit(idPublic) {
      this.$router.push({ name: 'editUser', params: { idPublic } });
    },
    cancelSearch() {
      this.searchText = '';
    },
  },
  computed: {
    userListComputed() {
      return this.list
        .map((user) => {
          if (user.isAdmin) {
            user.userStatus = 'ADMIN';
          } else {
            user.userStatus = 'STANDARD';
          }

          let statusHTMLIndex = this.statues.findIndex(
            (x) => x.code == user.userStatus
          );
          if (statusHTMLIndex >= 0) {
            user.userStatusHTML = this.statues[statusHTMLIndex].html;
          } else {
            user.userStatusHTML =
              '<span class="badge badge-danger badge-pill" style="font-size: 1em">' +
              this.$t('general.error').toUpperCase() +
              '</span>';
          }

          return user;
        })
        .filter((item) => {
          const name = item.name.toLowerCase();
          const searchTerms = this.searchText.toLowerCase().split(' ');
          let isValidElement = true;

          for (const x of searchTerms) {
            if (!name.includes(x)) {
              isValidElement = false;
            }
          }

          return isValidElement;
        });
    },
    fieldsComputed() {
      return [
        {
          key: 'name',
          label: this.$t('general.name'),
          class: 'table-row-expandable',
        },
        {
          key: 'role',
          label: this.$t('users.role'),
          class: 'table-row-relative',
        },
        {
          key: 'edit',
          label: this.$t('general.edit'),
          class: 'table-row-relative',
        },
      ];
    },
  },
};
</script>

<template>
  <Layout :title="$t('users.users')">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <div class="topbar">
      <b-form-group
        id="fieldset-1"
        :label="$t('general.search')"
        label-for="searchInput"
      >
        <b-form-input
          id="searchInput"
          type="text"
          style="min-width: 300px"
          :placeholder="$t('general.search')"
          @keydown.escape.prevent="cancelSearch()"
          v-model="searchText"
      /></b-form-group>
    </div>

    <GridComponent
      id="user-grid"
      :fields="fieldsComputed"
      :items="userListComputed"
    >
      <template #cell(name)="data">
        <div v-html="highlightMatches(data.value, searchText)"></div>
      </template>

      <template #cell(role)="data">
        <div v-html="data.item.userStatusHTML"></div>
      </template>

      <template #cell(edit)="data">
        <i
          class="fas fa-pencil-alt text-success pl-2 pr-2"
          @click="edit(data.item.idPublic)"
          style="cursor: pointer; font-size: 1.3em"
        ></i>
      </template>
    </GridComponent>
  </Layout>
</template>

<style scoped>
.topbar {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>